import { useAxios } from "./useAxios"
import { useBot } from "./useBot"

const axios = useAxios()

export interface CreateManualGroupSubscriptionDTO {
  leadIds: number[]
  groupIds: number[]
  paymentPlanId?: number
  expiresAt?: string
}

export interface RenewGroupSubscriptionDTO {
  expiresAt?: string | null
}

export function useGroupSubscription() {
  const { selectedBot } = useBot()

  const createManual = async (payload: CreateManualGroupSubscriptionDTO) => {
    const body: Record<string, any> = {
      leadIds: payload.leadIds,
      groupIds: payload.groupIds,
    }
    if (payload.paymentPlanId) body.paymentPlanId = payload.paymentPlanId
    if (payload.expiresAt) body.expiresAt = payload.expiresAt

    const response = await axios.post(
      `/bots/${selectedBot.value?.id}/group-subscriptions/manual`,
      body
    )

    return response.data
  }

  const renew = async (subscriptionId: number, payload?: RenewGroupSubscriptionDTO) => {
    const response = await axios.patch(
      `/bots/${selectedBot.value?.id}/group-subscriptions/${subscriptionId}/renew`,
      payload ?? {}
    )
    return response.data
  }

  const revoke = async (subscriptionId: number) => {
    const response = await axios.patch(
      `/bots/${selectedBot.value?.id}/group-subscriptions/${subscriptionId}/revoke`,
      {}
    )
    return response.data
  }

  return {
    createManual,
    renew,
    revoke,
  }
}
